<template>
  <div class="">
        <table class="table table-hover table-dark">
            <thead>
              <tr>
                <th scope="col" style="margin-left: -10px;">Machine</th>
                <th scope="col" style="margin-left: -10px;">Machine<br>State</th>
                <th scope="col" style="margin-left: -10px;">Current<br>Product</th>
                <th scope="col" style="margin-left: -10px;">Meters/<br>Minute</th>
                <th scope="col" style="margin-left: -10px;">Thresh</th>
                <th scope="col" style="margin-left: -10px;">Sensor<br>Status</th>
                <th scope="col" style="margin-left: -10px;" v-if="userType != 'viewer'">View</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="machine in extruderss" 
                :key="machine.id" 
                id="machine_row" 
                class="machine_status"
                :class="statusFomart(machine)"
                v-if="userType === 'Super Admin' || machine.machine_state !== 'DevStatus'">
                <div class="loader" v-if="extruderss.leagth = 0"></div>
                <td class="machine_name" style="margin-left: -10px;">{{ machine.machineName }}</td>
                <td>
                  <select 
                    :disabled="disabled"
                    :class="statusFomart(machine)"
                    v-model="machine.machine_state" 
                    @change="machine_config(machine)" >
                    <option disabled selected>{{ machine.machine_state  }}</option>
                    <option v-for="status in machine_status" :key="status.id">{{ status.name }}</option>
                  </select>
                </td>

                <td>
                  <select 
                    :disabled="disabled"
                    :class="statusFomart(machine)"
                    v-model="machine.product" 
                    @change="product_config(machine)" >
                    <option disabled selected>{{ machine.product  }}</option>
                    <option v-for="product in products" :key="product.id">{{ product.name }}</option>
                  </select>
                </td>

                <!--METERS PER MIUTE -->
                <td style="margin-left: -10px;"
                  v-if="
                    parseFloat((Number(machine['deltaPulses' + machine.MonitorInput]) / Number(machine.pulseConfig)) / (Number(machine['differenceInSeconds' + machine.MonitorInput]) / 60)).toFixed(2) < 0
                    ||
                    new Date().getTime() / 60000 - new Date(machine.updatedDate).getTime() / 60000 > machine.comm_interval
                  ">
                  0.00
                </td>
                <td style="margin-left: -10px;" v-else>
                  {{
                    (Number(machine.pulseConfig) > 0 && Number(machine['differenceInSeconds' + machine.MonitorInput]) > 0)
                      ? ((Number(machine['deltaPulses' + machine.MonitorInput]) / Number(machine.pulseConfig)) / (Number(machine['differenceInSeconds' + machine.MonitorInput]) / 60)).toFixed(2)
                      : '0.00'
                  }}
                </td>
              <!-- TIME LESS THAN COMM INTERVAL-->
                 <!--END METERS PER MINUTE -->

                <!--BELOW THRESH -->
                <td style="margin-left: -10px;">{{ machine.threshold }}</td>
                <!--STATUS -->
                <td style="margin-left: -10px;" v-if="new Date().getTime() / 60000 - new Date(`${machine.updatedDate} Z`).getTime() / 60000 < machine.comm_interval">On</td>
                <td style="margin-left: -10px;" v-else>Off</td>
                <td>
                <i class="fa fa-eye" @click="extruderChart(machine)" v-if="userType != 'viewer'"></i>
                </td>
              </tr>
            </tbody>
          </table>
     </div>
</template>
<script>
import axios from 'axios'
import http from '../../../services/http'
export default {
  data() {
  return {
    mechines: [],
    extruders: [],
    DeviceId: '',
    firtRaw: '',
    secondRaw: '',
    compare: '',
    meterPerMin: '',
    machineStatus: 1,
    sensorStatus: '',
    interval: null,
    machine_status: [],
    userType: '',
    disabled: false
    }
  },
  
computed: {
  extruderss() {
    return this.$store.state.machines.extruders
  },
  products() {
    return this.$store.state.products.extruderProduct
  }
},

mounted() {
 // console.log(this.$store.state.machines)
  this.allstatus();
   this.userType = localStorage.getItem('userType')
  if(this.userType == 'viewer')
  {
    this.disabled = true
  }
},

methods: {
//GET USER DETAILS
getUserDetails() {
  let userDetails = localStorage.getItem('userType')
  this.userType = userDetails
},

statusFomart(machine) {
  let oldDateTime = new Date(machine.updatedDate + 'Z');
  let currentTime = new Date();
  currentTime = currentTime.getTime();
  oldDateTime = oldDateTime.getTime();

  var threshhold_status = (Number(machine['deltaPulses' + machine.MonitorInput]) / Number(machine.pulseConfig) / (Number(machine['differenceInSeconds' + machine.MonitorInput]) / 60)) >= machine.threshold
  //console.log(threshhold_status)
  let On;
  let machineOn;
  let Of

  if((currentTime / 1000) - (oldDateTime / 1000) < machine.comm_interval && threshhold_status == true) 
  {
    On = true
  }
  if((currentTime / 1000) - (oldDateTime / 1000) > machine.comm_interval) 
  {
    On = false
  } else if(machine.status == 0 && (currentTime / 1000) - (oldDateTime / 1000) > machine.comm_interval) 
  {
    Of = true
  }else if (machine.status == 0 || threshhold_status == false && (currentTime / 1000) - (oldDateTime / 1000) < machine.comm_interval)
  {
    machineOn = true
  }
  return {
    yellow: machineOn,
    danger: !On,
    success: On,
    Off: Of
  }
},

  extruderChart(machine) 
    {
     this.$router.push('/ExtruderCharts/' + machine.machineName)
    },

product_config(machine) {
        http.patch('/api/machines/product', {
          machine_name: machine.machineName,
          product: machine.product,
        }).catch((error) => { console.log(error) })
      },

machine_config(machine) {
        http.patch('/api/machines/state', {
          machine_name: machine.machineName,
          machine_state: machine.machine_state,
        }).catch((error) => { console.log(error) })
      },     
      
 //SELECT ALL STATUS
  allstatus() {
       http.get('/api/machine-states')
          .then((res) => {
            this.machine_status = res.data
          })
          .catch(function (error) {
              console.log(error)
          })
      }
 }
}
</script>
<style scoped>
tbody tr:hover,
tbody tr:active {
  background-color: #A9A9A9;
}

.Off {
  background-color: red;
  color: white;
  }

.machine_status._0 {
  background-color: orange;
  color: #fff;
  }

.machine_status._1 {
  background-color: green;
  color: #fff;
  }

.On {
  background-color: green;
  color: white;
  }

tr {
   line-height: 15px;
   min-height: 15px;
   height: 15px;
   word-wrap: break-word;
   width: 10px;
}

.success {
  background-color: green !important;
}

.danger {
  background-color: red !important;
}

.yellow {
  background-color: orange !important;
}

.threshold {
  background-color: orange !important;
}

select {
   min-height: 10px;
   height: 15px;
   word-wrap: break-word;
   max-width: 80%;
   color: white;
   border: none;
}

/* LOADING CIRCLE */
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>